/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export interface ANSTypeSubType {
  type: string;
  subtype: string;
}

export enum MessageTypes {
  APPROVAL_REQUEST = 'approval_request',
  APPROVAL_REQUEST_ACTION = 'approval_request_action',
  ACCESS_REQUEST = 'access_request',
  ACCESS_REQUEST_ACTION = 'access_request_action',
  ASSIGNED = 'assigned',
  SHARED = 'shared',
  MENTIONS = 'mentions',
  UPDATES_ON_SUBSCRIBED_OBJECT = 'updates_on_subscribed_object',
  ERROR_COMPLETED_WITH_ERRORS = 'completed_with_errors',
  ERROR_FAILED_WITH_ERRORS = 'failed_with_errors',
  ERROR_DEFAULT_MESSAGE = 'errors_default_message',
  OTHERS = 'others'
}

const mappings = new Map<string, ANSTypeSubType>([
  [MessageTypes.APPROVAL_REQUEST, {type: 'com.adobe.exc.v1.approval', subtype: 'request.received'}],
  [MessageTypes.APPROVAL_REQUEST_ACTION, {type: 'com.adobe.exc.v1.approval', subtype: 'request.action'}],
  [MessageTypes.ACCESS_REQUEST, {type: 'com.adobe.exc.v1.access', subtype: 'request.received'}],
  [MessageTypes.ACCESS_REQUEST_ACTION, {type: 'com.adobe.exc.v1.access', subtype: 'request.action'}],
  [MessageTypes.ASSIGNED, {type: 'com.adobe.exc.v1.assigned', subtype: 'com.adobe.exc.v1.default'}],
  [MessageTypes.SHARED, {type: 'com.adobe.exc.v1.shared', subtype: 'com.adobe.exc.v1.default'}],
  [MessageTypes.MENTIONS, {type: 'com.adobe.exc.v1.my_mentions', subtype: 'com.adobe.exc.v1.default'}],
  [
    MessageTypes.UPDATES_ON_SUBSCRIBED_OBJECT,
    {type: 'com.adobe.exc.v1.updates_on_subscribed_object', subtype: 'com.adobe.exc.v1.default'}
  ],
  [MessageTypes.OTHERS, {type: 'com.adobe.exc.v1.others', subtype: 'com.adobe.exc.v1.default'}],
  [
    MessageTypes.ERROR_COMPLETED_WITH_ERRORS,
    {type: 'com.adobe.exc.v1.errors', subtype: 'com.adobe.exc.v1.process_complete_with_errors'}
  ],
  [
    MessageTypes.ERROR_FAILED_WITH_ERRORS,
    {type: 'com.adobe.exc.v1.errors', subtype: 'com.adobe.exc.v1.process_failed_with_errors'}
  ],
  [MessageTypes.ERROR_DEFAULT_MESSAGE, {type: 'com.adobe.exc.v1.errors', subtype: 'com.adobe.exc.v1.default'}]
]);

export default mappings;
